import type { CompareOccurrencesByPage } from "./types";

const pageNumberOf = (page: string): number =>
  parseInt(page.replace(/\D/g, ""), 10) || 0;

export const compareOccurrencesByPage: CompareOccurrencesByPage = (
  left,
  right,
) => pageNumberOf(left.page) - pageNumberOf(right.page);
